// import { useContext, useEffect, useRef, useState } from 'react';
import css from './ContactGT.module.scss';
// import Filter from './components/Filter/Filter';
import Skeleton from '../../../widgets/plug/Skeleton/Skeleton';
// import UserContext from '../../../common/utils/getContext';
// import { getData } from '../../../common/utils/router';
import { skeleton } from './helpers';
// import Map from './components/Map/Map';
// import classNames from 'classnames';
// import { svgSprite } from '../../../hybrid/wrappers';
// import Link from 'next/link';
// import T from '../../../common/components/T';
// import { checkBrowser } from '../../../common/utils/utils';
import Feedback from './components/Feedback/FeedBack';
import LogoWithVideo from '../../../widgets/ogoWithVideo/LogoWithVideo';
// import { useWindowDimensions } from '../../../common/utils/windowDimensions';
// import Plug from '../../../widgets/plug/Plug/Plug';

const RenderData = () => {
    // const { centers } = props;
    // const [radio, setRadio] = useState(0);
    // const [filter, setFilter] = useState(null);
    // const [selectedCenter, setSelectedCenter] = useState(null);
    // const mapRef = useRef();
    // const centerRef = useRef();
    // const filterRef = useRef();
    // const [filteredCenters, setFilteredCenters] = useState(centers?.data?.map(setCenter));
    // const width = useWindowDimensions();
    // const [mobileFilter, showMobileFilter] = useState(false);

    // useEffect(() => {
    //     if (mapRef.current && centerRef.current) {
    //         const mapRefHeight = mapRef.current.getBoundingClientRect().height;
    //         centerRef.current.style.height = mapRefHeight - 40 - 35 + 'px';
    //     }
    // }, [mapRef.current, centerRef.current, selectedCenter]);

    // useEffect(() => {
    //     if (filterRef.current) {
    //         const elem = filterRef.current;
    //         const parent = filterRef.current.parentElement;
    //         const elemPOS = elem.getBoundingClientRect();
    //         const parentPOS = parent.getBoundingClientRect();

    //         const listener = () => {
    //             if (checkBrowser(parentPOS.height) - checkBrowser(elemPOS.height) - window.scrollY < 0) {
    //                 elem.style.transform = `translateY(${checkBrowser(parentPOS.height) - checkBrowser(elemPOS.height)}px)`;
    //             } else {
    //                 elem.style.transform = `translateY(${window.scrollY}px)`;
    //             }
    //         };
    //         listener();
    //         window.addEventListener('scroll', listener);

    //         return () => {
    //             window.removeEventListener('scroll', listener);
    //         };
    //     }
    // }, [filterRef.current, radio, width, filteredCenters]);

    return (
        <div className={css.wrapper}>
            {/* <div className={css.blockOne}>
                <div ref={filterRef} className={classNames(css.filter, (selectedCenter || width < 992) && css.dn)}>
                    <Filter setFilter={setFilter} filter={filter} radio={radio} setRadio={setRadio} />
                </div>
                <div onClick={() => showMobileFilter(true)} className={css.filterMobile}>
                    <p className={css.filterMobileTitle}>
                        <T textName='filter' defaultStr='Фильтр' page='/contact' />
                    </p>
                    {mobileFilter ? (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                showMobileFilter(false);
                            }}
                            className={classNames('circleButton', css.filterMobileClose)}
                        >
                            {svgSprite('cross-gt')}
                        </div>
                    ) : null}
                    {mobileFilter ? (
                        <div className={css.filterMobileBody}>
                            <Filter setFilter={setFilter} filter={filter} radio={radio} setRadio={setRadio} />
                        </div>
                    ) : null}
                </div>
                {selectedCenter ? (
                    <div className={css.filter}>
                        <div ref={centerRef} className={css.center}>
                            <div className={css.centerHead}>
                                <p className={css.centerName}>{`${selectedCenter.type?.title} ${selectedCenter.name}`}</p>
                                <div
                                    onClick={() => setSelectedCenter(null)}
                                    className={classNames('circleButton', css.closeCenter)}
                                >
                                    {svgSprite('cross-gt')}
                                </div>
                            </div>
                            <div className={css.centerBody}>
                                {selectedCenter?.contacts?.map((contact) => (
                                    <div className={css.centerContact} key={contact.type}>
                                        <Link className={css.centerLink} href={getContactValue(contact)} target='_blank'>
                                            <p className={css.centerContactName}>{contact.value}</p>
                                            {contact.description ? (
                                                <p className={css.centerContactDescription}>{contact.description}</p>
                                            ) : null}
                                        </Link>
                                        {contact?.messengers ? (
                                            <div className={css.centerPhoneMessengers}>
                                                {contact?.messengers.map((mes) => (
                                                    <Link
                                                        target='_blank'
                                                        href={getContactValue(mes)}
                                                        key={mes.type}
                                                        className={classNames('circleButton', 'grow', css.centerMessengerCircle)}
                                                    >
                                                        {svgSprite(mes.type + '-colored')}
                                                    </Link>
                                                ))}
                                            </div>
                                        ) : null}
                                    </div>
                                ))}
                                {selectedCenter?.custom_contacts?.map((contact) => (
                                    <div className={css.centerContact} key={contact.type}>
                                        <div className={classNames(css.centerLink, css.centerLinkOff)}>
                                            <p className={css.centerContactName}>{contact.value}</p>
                                            {contact.description ? (
                                                <p className={css.centerContactDescription}>{contact.description}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                ))}
                                <div className={css.centerContact}>
                                    <div className={classNames(css.centerLink, css.centerLinkOff)}>
                                        <p className={css.centerContactName}>{selectedCenter?.address}</p>
                                        <p className={css.centerContactDescription}>
                                            {
                                                <T
                                                    textName='center-address-label'
                                                    defaultStr='Предварительно обязательно звонить'
                                                    page='/contact'
                                                />
                                            }
                                        </p>
                                    </div>
                                </div>
                                {selectedCenter?.messengers?.map((mes) => (
                                    <Link
                                        key={generateUniqueId()}
                                        className={classNames(css.cardMessenger)}
                                        href={getContactValue(mes)}
                                    >
                                        {svgSprite(mes.type || 'cross-gt')}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : null}
                <div className={classNames(css.map, (radio === 1 || (selectedCenter && width < 992)) && css.dn)}>
                    <Map
                        setCenters={(data) => setFilteredCenters(data?.map(setCenter))}
                        custRef={mapRef}
                        funcs={{ onMarkerClick: (center) => setCenter(center, setSelectedCenter) }}
                        radio={radio}
                        data={{ departments: centers }}
                        filter={filter}
                    />
                </div>
                <div className={classNames(css.map, radio === 0 && css.dn)}>
                    {filteredCenters?.length ? (
                        filteredCenters?.map((center) => (
                            <div className={css.card} key={center.id}>
                                <div className={css.cardLeft}>
                                    <p className={css.cardTitle}>{`${center.type?.title} ${center.name}`}</p>
                                    <div className={css.cardMessengers}>
                                        {center?.messengers?.map((mes) => (
                                            <Link
                                                key={generateUniqueId()}
                                                className={classNames(css.cardMessenger)}
                                                href={getContactValue(mes)}
                                            >
                                                {svgSprite(mes.type || 'cross-gt')}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                                <div className={css.cardRight}>
                                    {center?.contacts?.map((contact) => (
                                        <div className={css.centerContact} key={generateUniqueId()}>
                                            <Link className={css.centerLink} href={getContactValue(contact)} target='_blank'>
                                                <p className={css.centerContactName}>{contact.value}</p>
                                                {contact.description ? (
                                                    <p className={css.centerContactDescription}>{contact.description}</p>
                                                ) : null}
                                            </Link>
                                            {contact?.messengers ? (
                                                <div className={css.centerPhoneMessengers}>
                                                    {contact?.messengers.map((it) => (
                                                        <Link
                                                            target='_blank'
                                                            href={getContactValue(it)}
                                                            key={generateUniqueId()}
                                                            className={classNames(
                                                                'circleButton',
                                                                'grow',
                                                                css.centerMessengerCircle
                                                            )}
                                                        >
                                                            {svgSprite(it.type + '-colored')}
                                                        </Link>
                                                    ))}
                                                </div>
                                            ) : null}
                                        </div>
                                    ))}
                                    {center?.custom_contacts?.map((contact) => (
                                        <div className={css.centerContact} key={generateUniqueId()}>
                                            <div className={classNames(css.centerLink, css.centerLinkOff)}>
                                                <p className={css.centerContactName}>{contact.value}</p>
                                                {contact.description ? (
                                                    <p className={css.centerContactDescription}>{contact.description}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                    ))}
                                    <div className={css.centerContact}>
                                        <div className={classNames(css.centerLink, css.centerLinkOff)}>
                                            <p className={css.centerContactName}>{center?.address}</p>
                                            <p className={css.centerContactDescription}>
                                                {
                                                    <T
                                                        textName='center-address-label'
                                                        defaultStr='Предварительно обязательно звонить'
                                                        page='/contact'
                                                    />
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <Plug
                            plugTitle={
                                <T textName='no-departments-found' defaultStr='Центры обслуживания отсутствуют' page='/contact' />
                            }
                            plugDescription={
                                <T
                                    textName='no-departments-found-descript'
                                    defaultStr='За вашим запросом отсутствуют центры обслуживания. Попробуйте изменить фильтр'
                                    page='/contact'
                                />
                            }
                            plugImg={'/src/img/plugs/something_wrong.svg'}
                        />
                    )}
                </div>
            </div> */}
            <div className={css.blockTwo}>
                <Feedback />
                <LogoWithVideo />
            </div>
        </div>
    );
};

const ContactGT = () => {
    // const { userToken, lang } = useContext(UserContext);
    // const [centers, setCenters] = useState(null);

    // useEffect(() => {
    //     getData(
    //         '/api/v1/company/departments?page[size]=999&filter[active]=1&include=contacts,customContacts,country,region,city',
    //         userToken,
    //         lang
    //     ).then((res) => {
    //         setCenters(res);
    //     });
    // }, [userToken, lang]);

    return <Skeleton wait={1} Component={RenderData} pattern={skeleton} wrapperStyles={css.skeleton} />;
};

export default ContactGT;
